import { LessonDetail } from "./LessonDetail";
import { Classwork } from "./Classwork";
import { InClassPhotos } from "./InClassPhotos";
import { StudentReport } from "./StudentReport";

export const tabs = [
    {
        index: 0,
        name: "Lesson Details",
        Component: LessonDetail,
    },
    {
        index: 1,
        name: "Student Report",
        Component: StudentReport,
    },
    {
        index: 2,
        name: "Classwork",
        Component: Classwork,
    },
    {
        index: 3,
        name: "In Class Photos",
        Component: InClassPhotos,
    },
];
